import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import UsersGrid from './grid';
import './users.scss';
import { AppToaster } from '../shared/toaster';
import { toUserMessage } from './users-util';
import convertErrorCodeToMessage from '../shared/errorCodeConvert/convertErrorCodeToMessage';

class UserFrame extends React.Component<any, any> {
  handleChange = (e: any) => {
    this.setState({ selectedTab: e });
  }

  handleViewChange = (e: any) => {
    this.setState({ selectedView: e.currentTarget.id });
  }

  componentDidUpdate() {
    const { t } = this.props;
    const { error } = this.props.users;
    let message: any;
    if (error.errorCode === 'PASSWORD_POLICY_FAILURE') {
      message = toUserMessage(error.errorMessage, this.props.securityPolicy.entities);
    } else {
      message = convertErrorCodeToMessage(error);
    }

    if (error.errorCode != null || error.errorMessage != null) {
      AppToaster.show({
        icon: 'error',
        intent: 'danger',
        timeout: 0,
        message: t('common.toast.error', { error: message }),
      });
      this.props.clearErrors();
    }
    if (!this.props.authentication.isAuthenticated) {
      this.props.history.push('/authentication/login');
    }
  }

  render() {
    return (
      <Fragment>
        <div className="col-md-12" style={{ height: 'inherit' }}>
          <UsersGrid {...this.props} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  securityPolicy: state.securityPolicy,
});

export default withTranslation()(connect(mapStateToProps, null)(UserFrame));
